export default __webpack_public_path__ + "static/img-media-yahoo-nft-a9281d35b8e2b59856c01bfbb513f48f.jpeg";